import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { Customer } from "@redotech/redo-model/customer";
import { MarketingChannel } from "@redotech/redo-model/marketing";

export enum MarketingSuppressionScope {
  TEAM = "team",
  GLOBAL = "global",
}
export enum MarketingSuppressionReason {
  PERMANENT_ERROR = "permanent_error",
  TEMPORARY_ERROR = "temporary_error",
  INVALID_CHANNEL_ID = "invalid_channel_id",
  MERCHANT = "merchant",
  SPAM_COMPLAINT = "spam_complaint",
}
export const GLOBAL_SUPPRESSION_REASONS = [
  MarketingSuppressionReason.PERMANENT_ERROR,
  MarketingSuppressionReason.INVALID_CHANNEL_ID,
] as const;

const marketingSuppression = z.object({
  teamId: zExt.objectId(),
  channel: createEnum(MarketingChannel),
  channelId: z.string(),
  reason: createEnum(MarketingSuppressionReason),
  count: z.number(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type MarketingSuppression = z.infer<typeof marketingSuppression>;

export type CustomerWithSuppressionReasons = Customer & {
  emailSuppressionReasons: MarketingSuppressionReason[];
  smsSuppressionReasons: MarketingSuppressionReason[];
};
